module.exports = __webpack_public_path__ + "static/media/2_nature.16eb5da7.jpg";